import { ShipmentPlanApiModel, ShipmentPlanParcelApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { uid } from '../../../../lib/helpers/uid';
import { MapMarketplaceOrderlineToConsignmentParcel } from '../../grouping/MapMarketplaceOrderlineToConsignmentParcel';

export function SmartSendItemsToConsignment(items: SmartSendItemApiModel[]) {
  const res: ShipmentPlanApiModel = { Parcels: [] };
  items.forEach((i) => {
    const parcel: ShipmentPlanParcelApiModel = {
      Contents: [],
      Dimensions: i.PackageDimensions,
      Id: i.Id,
      UID: uid(),
      CanAdd: i.Source.Id === 'grouped'
    };
    i.MarketplaceOrderLines.forEach((m) => {
      parcel.Contents.push({
        ...MapMarketplaceOrderlineToConsignmentParcel(m),
        Id: m.Id,
        UID: uid(),
        Value: m.Value
      });
    });
    res.Parcels.push(parcel);
  });
  return res;
}
